// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'es6-promise/auto'
import 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ko'
import { DataTables, DataTablesServer } from 'vue-data-tables'
import BootstrapVue from 'bootstrap-vue'
import VueProgressBar from 'vue-progressbar'
import DrawerLayout from 'vue-drawer-layout'
import VueAnalytics from 'vue-analytics'
import Clipboard from 'v-clipboard'

import App from './App'
import router from './router'
import store from './store'

// Global CSS
// import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap-reboot.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/webfonts/fontawesome-all.min.css'
import '@/assets/css/common.css'
import '@/assets/less/index.less'
import '@/assets/scss/index.scss'

Vue.config.productionTip = false

Vue.use(ElementUI, {locale})
Vue.use(DataTables)
Vue.use(DataTablesServer)
Vue.use(BootstrapVue)
Vue.use(VueProgressBar)
Vue.use(DrawerLayout)
Vue.use(VueAnalytics, {
  id: 'UA-43655520-3',
  router
})
Vue.use(Clipboard)

// Progressbar 옵션 설정
const progressbarOptions = {
  color: '#bffaf3',
  thickness: '6px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 1000
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}

Vue.use(VueProgressBar, progressbarOptions)

Vue.component('excel', {
  props: {name: String, click: Function, loading: Boolean},
  template: '<el-button class="btn btn-excel" :loading="loading" @click="excelHandler">{{name}}</el-button>',
  methods: {
    excelHandler () {
      this.$emit('click')
    }
  }
})

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js